import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles/tw.css';

const container = document.getElementById('root');
if (container) {
  const root = createRoot(container);
  root.render(<App />);
} else {
  console.warn('No root element found. Skipping React mount.');
}
